// extracted by mini-css-extract-plugin
export default {"CategoryBlock":"style_CategoryBlock__pvjir","CategoryBlock__error":"style_CategoryBlock__error__l8HwD","dataContainer":"style_dataContainer__g0GEf"};